// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1oMRJ","form":"styles_form__9312s"};